module.exports = __webpack_public_path__ + "img/chronicle.49ee1b5a.png";